import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useSiteContent } from "@/context/SiteContentContext";

export const Navbar = () => {
  const { content } = useSiteContent();
  const nav = content.navbar;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: nav.link_home },
    { to: "/projeler", label: nav.link_projects },
    { to: "/hakkimizda", label: nav.link_about },
    { to: "/iletisim", label: nav.link_contact },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-[var(--ivory)]/95 backdrop-blur-md border-b border-[var(--gold)]/20 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link">
          <Logo variant="light" size="md" />
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-[0.78rem] tracking-[0.22em] uppercase font-light transition-colors ${isActive ? "text-[var(--gold)]" : "text-[var(--navy)] hover:text-[var(--gold)]"}`
              }>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/iletisim" className="btn-primary" data-testid="nav-cta-contact">{nav.cta_label}</Link>
        </div>

        <button aria-label="menu" data-testid="nav-mobile-toggle" className="lg:hidden p-2 text-[var(--navy)]" onClick={() => setOpen((s) => !s)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[var(--ivory)] border-t border-[var(--gold)]/20 px-6 py-6" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {navLinks.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-mobile-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) => `text-sm tracking-[0.2em] uppercase ${isActive ? "text-[var(--gold)]" : "text-[var(--navy)]"}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/iletisim" className="btn-primary self-start mt-2" data-testid="nav-mobile-cta">{nav.cta_label}</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
